import type { Schema } from 'effect';

import type { BackendApiErrorUnion } from '../../data/error/backendApi/_internal/createBackendApiError';
import type { SearchSuggestAdapters } from './searchAdapters';
import { makeGetSearchSuggest } from '../../request/backendApi/search/makeGetSearchSuggest';
import type { StripJsonLd } from '@vs-shop/schemas/transform/withoutJsonLd';

/** Engine-side search module, composed from its original request factory. */
export type SearchModuleDeps<SuggestResult extends Schema.Top> = {
  readonly suggestResult: SuggestResult;
  readonly searchSuggestAdapters: SearchSuggestAdapters<StripJsonLd<SuggestResult['Type']>>;
};

export const makeSearchModule = <SuggestResult extends Schema.Top>(
  deps: SearchModuleDeps<SuggestResult>
) => {
  const searchSuggest = makeGetSearchSuggest({
    suggestResult: deps.suggestResult,
    searchSuggestAdapters: deps.searchSuggestAdapters,
  });

  return {
    getSearchSuggest: searchSuggest.getSearchSuggest,
    requestSearchSuggest: searchSuggest.requestSearchSuggest,
    GetSearchSuggestError: searchSuggest.GetSearchSuggestError,
  };
};

export type SearchGetSearchSuggestError = BackendApiErrorUnion<
  ReturnType<typeof makeSearchModule>['GetSearchSuggestError']
>;
